@if (loading() && !magazine()) {
  <section class="section magazine-viewer-section">
    <div class="section-inner" style="display:flex;justify-content:center;">
      <app-book-loader size="full" label="Opening magazine…"></app-book-loader>
    </div>
  </section>
} @else if (magazine(); as mag) {
  <section class="magazine-viewer-fullscreen" aria-label="Magazine reader" @fadeInUp>
    <div class="reader-toolbar" [class.is-hidden]="!toolbarVisible()">
      <a class="magazine-viewer-back-float" routerLink="/magazine">← Back to Magazines</a>
      <p class="magazine-viewer-title-float">{{ mag.MagTitle }}</p>
      <div class="reader-progress" aria-hidden="true">
        <div class="reader-progress__bar" [style.width.%]="pdfSrc() ? 100 : pdfLoading() ? 45 : 10"></div>
      </div>
    </div>

    @if (pdfLoading()) {
      <div class="magazine-viewer-empty">
        <app-book-loader size="full" label="Loading PDF…"></app-book-loader>
      </div>
    } @else if (pdfSrc(); as src) {
      <iframe
        class="magazine-viewer-frame-fullscreen"
        [src]="src"
        [title]="mag.MagTitle + ' PDF viewer'"
        loading="eager"
      ></iframe>
    } @else {
      <div class="magazine-viewer-empty">
        <h2 class="section-title">PDF <em>unavailable</em></h2>
        <p class="magazine-viewer-note">{{ pdfError() || 'This issue does not have a readable PDF yet.' }}</p>
        <a class="btn-primary" routerLink="/magazine">Browse Magazines</a>
      </div>
    }
  </section>
} @else {
  <section class="section magazine-viewer-section">
    <div class="section-inner">
      <div class="magazine-viewer-empty">
        <h2 class="section-title">Magazine <em>not found</em></h2>
        <p class="magazine-viewer-note">The issue you requested is unavailable.</p>
        <a class="btn-primary" routerLink="/magazine">Browse Magazines</a>
      </div>
    </div>
  </section>
}
